import { render } from "./TenderCard.vue?vue&type=template&id=62a70f3e&ts=true"
import script from "./TenderCard.vue?vue&type=script&lang=ts"
export * from "./TenderCard.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__